import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 1092 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1092 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-close\"><defs><style type=\"text/css\"></style></defs><path d=\"M613.034667 512l416.017066 416.017067L933.000533 1024 517.051733 607.982933 101.034667 1024 5.051733 928.017067 421.000533 512 5.051733 95.982933 101.034667 0l416.017066 416.017067L933.000533 0l96.0512 95.982933z\" p-id=\"2183\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol